/* BICH Broschüre: Rotator für Werbebanner (keine Preislogik, keine Warenkorb-Funktion) */
(function () {
  if (customElements.get('bichb-rotator')) return;
  class BichbRotator extends HTMLElement {
    connectedCallback() {
      var track = this.querySelector('.bichb-rotator__track');
      this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-bichb-slide]'));
      if (this.slides.length < 2) return;
      // zufällige Reihenfolge = wechselnde Produkte bei jedem Besuch
      for (var i = this.slides.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var t = this.slides[i]; this.slides[i] = this.slides[j]; this.slides[j] = t;
      }
      this.slides.forEach(function (s) { track.appendChild(s); });
      var dots = this.querySelector('[data-bichb-dots]');
      var self = this;
      this.dots = this.slides.map(function (s, idx) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'bichb-rotator__dot';
        b.setAttribute('aria-label', 'Produkt ' + (idx + 1) + ' von ' + self.slides.length);
        b.addEventListener('click', function () { self.show(idx, true); });
        dots && dots.appendChild(b);
        return b;
      });
      var prev = this.querySelector('[data-bichb-prev]'), next = this.querySelector('[data-bichb-next]');
      prev && prev.addEventListener('click', function () { self.show(self.i - 1, true); });
      next && next.addEventListener('click', function () { self.show(self.i + 1, true); });
      this.addEventListener('mouseenter', function () { self.paused = true; });
      this.addEventListener('mouseleave', function () { self.paused = false; });
      this.addEventListener('focusin', function () { self.paused = true; });
      this.addEventListener('focusout', function () { self.paused = false; });
      this.i = 0; this.show(0, false);
      var ms = Math.max(4, parseInt(this.dataset.interval || '7', 10)) * 1000;
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.timer = setInterval(function () { if (!self.paused && !document.hidden) self.show(self.i + 1, false); }, ms);
      }
    }
    disconnectedCallback() { clearInterval(this.timer); }
    show(n, user) {
      var len = this.slides.length;
      this.i = (n + len) % len;
      var cur = this.i;
      this.slides.forEach(function (s, k) {
        if (k === cur) { s.hidden = false; s.classList.add('is-active'); } else { s.hidden = true; s.classList.remove('is-active'); }
      });
      this.dots.forEach(function (d, k) { d.setAttribute('aria-current', k === cur ? 'true' : 'false'); });
      if (user) this.paused = true;
    }
  }
  customElements.define('bichb-rotator', BichbRotator);
})();
